import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../analytics';

// Records a first-party pageview on every route change (in-app analytics — no Google, no
// cookies). Mounted inside the Router in index.tsx. Skips the react-snap prerender crawl;
// the send itself is gated to production inside analytics.ts.
export default function RouteAnalytics() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        if (navigator.userAgent === 'ReactSnap') return;
        trackPageview(pathname + search);
    }, [pathname, search]);

    return null;
}
